const { get } = require('./api');

const editRFQ = () => {

	const $triggers = document.querySelectorAll('.js-edit-rfq');

	let apiTimeout;

	// sets the table data in the Modal
	const updateModal = ($modal, data) => {
		const $table = $modal.querySelector('.parts-table');
		
		if (!$table) {
			return;
		}
		$table.querySelector('tbody').innerHTML = '';


		const $pl = $modal.querySelector('input.PartListField');
		if (!!$pl) {
			$pl.value = JSON.stringify(data);
		}
		
		if (!data || data.length < 1) 
		{
			const $navCarts = document.querySelectorAll(".js-navbar-cart");
			if ($navCarts.length > 0) {
				$navCarts.forEach($cart => $cart.classList.remove("has-badge"));
			}
		}

		data.forEach(items => {
			let $tr = document.createElement('tr');

			Object.keys(items).forEach(item => {
				let $td = document.createElement('td');
				if (item == 'name') {
					$td.innerText = items.name;
					$tr.appendChild($td);
				} else if (item == 'qty') {
					let $input = document.createElement('input');
					$input.name = items.partnr;
					$input.readonly - true;
					if (items.qty === null) {
						$input.value = 1;
						$input.type = 'hidden';
					} else {
						$input.value = items.qty;
					}
					$td.appendChild($input);
					$tr.appendChild($td);
				}
			});



			$table.querySelector('tbody').appendChild($tr);
		});
	}


	// gets the data from the Table in the RFQ view
	const getTableData = ($table) => {
		let data = [];
		$table.querySelectorAll('tbody tr').forEach($el => {
			let item = {
				'partnr': $el.getAttribute('data-edit-rfq-partnr'),
				'name': $el.querySelector('td:first-child').innerText,
				'qty': $el.querySelector('.qty') ? $el.querySelector('.qty').value : null
			};

			data.push(item);

		})

		return data;
	}

	// initialize Edit logic
	$triggers.forEach($el => {
		const isDebug = ($el.getAttribute('data-debug') == 'true') ? true : false;
		const formAction = $el.getAttribute('data-edit-rfq-action');
		const RFQType = $el.getAttribute('data-edit-rfq-type');

		const modal = $el.closest('.your-rfq-section').querySelector('.button.js-modal').getAttribute('data-modal-target');

		const $this = $el;
		let inputTimeout;

		updateModal(document.querySelector(`#${modal}`), getTableData($el));

		$this.querySelectorAll('tbody tr').forEach($el => {
			const partnr = $el.getAttribute('data-edit-rfq-partnr');
			const minimum = $el.getAttribute('data-edit-rfq-min');

			const $qty = $el.querySelector('.qty');
			const $del = $el.querySelector('.remove');

			if ($qty) {
				$qty.addEventListener('input', ev => {
					ev.target.value = ev.target.value.replace(/\D/g, '');

					clearTimeout(inputTimeout);
					inputTimeout = setTimeout(() => {
						if (Number(ev.target.value) < minimum) {
							$el.classList.add('has-error');
						} else {
							$el.classList.remove('has-error');
							postForm(partnr, ev.target.value, RFQType);
						}
					}, 200);
				});

				// plus and minus controls
				$el.querySelector('.increase').addEventListener('click', ev => {
					if (Number($qty.value) < minimum) {
						$qty.value = minimum;
						$el.classList.remove('has-error');

						clearTimeout(inputTimeout);
						inputTimeout = setTimeout(() => {
							postForm(partnr, $qty.value, RFQType);
						}, 200);
					} else {
						$qty.value++;
						clearTimeout(inputTimeout);
						inputTimeout = setTimeout(() => {
							postForm(partnr, $qty.value, RFQType);
						}, 200);
					}
				});
				$el.querySelector('.decrease').addEventListener('click', ev => {
					if (Number($qty.value) == minimum) {
						$qty.value = minimum;
					} else if (Number($qty.value) < minimum) {
						$qty.value = minimum;
						$el.classList.remove('has-error');

						clearTimeout(inputTimeout);
						inputTimeout = setTimeout(() => {
							postForm(partnr, $qty.value, RFQType);
						}, 200);
					} else {
						$qty.value--;
						clearTimeout(inputTimeout);
						inputTimeout = setTimeout(() => {
							postForm(partnr, $qty.value, RFQType);
						}, 200);
					}
				});
			}

			if ($del) {
				$del.addEventListener('click', ev => {
					ev.preventDefault();
					$el.remove();
					postForm(partnr, 0, RFQType);
					if ($this.querySelectorAll('tbody tr').length < 1) $this.closest('.your-rfq-section').remove();
				});
			}

		});


		const postForm = (partnr, qty = 1, RFQType) => {
			if (isDebug) {
				clearTimeout(apiTimeout);
				console.log('debug mode, response is Success!');
				apiTimeout = setTimeout(() => {
					onSuccess(qty);
				}, 1500)

			} else {
				get(`${formAction}?type=${RFQType}&qty=${qty}&pn=${partnr}`, onSuccess, onFail); // 2.
			}
		}

		const onSuccess = (data) => {
			// update it with the new values
			updateModal(document.querySelector(`#${modal}`), getTableData($el));
		}

		const onFail = (data) => { // 2A.
			// Failed to contact server
			console.warn('Failed to contact server');
		}
	});



};

module.exports = {
	init: editRFQ
};
